import axios from "axios";
import React, { useEffect, useState } from "react";
import Loader from "../Loader/Loader";
import Navbar from "../Navbar/Navbar";
import NewTodo from "../NewTodo/NewTodo";
import Todo from "../Todo/Todo";

const Home = ({setuser}) => {
  const [todos, settodos] = useState([]);
  const [loading,setLoading]  = useState(false)


  useEffect(()=>{
    async function fetchtodos(){
      try{
        setLoading(true)
        const {data} = await axios.get("/api/todo/all",{withCredentials:true});
        settodos(data.todos);
        setLoading(false)
      }
      catch(err){
        console.log(err.response.data.msg);
        setLoading(false)
      }
    }
    fetchtodos()
  },[])

  if(loading) return <Loader/> 

  return (
    <>
        <Navbar setuser={setuser} setLoading={setLoading}/>
        <NewTodo settodos={settodos} setloading={setLoading} />
        { 
          todos &&
          todos.map((todo,index)=>{
            return <Todo key={index} todo={todo} settodos={settodos} setLoading={setLoading}/>
          })
        }      
        </>
  );
};

export default Home;
